import save from '../Services/save'

export default async (values, dispatch) => dispatch(save(values))
